import { render, staticRenderFns } from "./Grades.vue?vue&type=template&id=6001ae9b&"
import script from "./Grades.vue?vue&type=script&lang=js&"
export * from "./Grades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6001ae9b')) {
      api.createRecord('6001ae9b', component.options)
    } else {
      api.reload('6001ae9b', component.options)
    }
    module.hot.accept("./Grades.vue?vue&type=template&id=6001ae9b&", function () {
      api.rerender('6001ae9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/Grades.vue"
export default component.exports